import { TCreateUserReq } from "@sharedTypes/req.type";
import { TCreateUserRes } from "@sharedTypes/res.type";

import missingParametersError from "api/Error";
import axios from "axios";

export async function CreateUser(
  firstName: string,
  lastName: string,
  email: string,
  password: string,
) {
  const apiUrl = "/auth/createuser";

  const body: TCreateUserReq = {
    firstName,
    lastName,
    email,
    password,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TCreateUserRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
